import { useEffect, useState } from 'react';
import { NFL_TEAMS, DIVISIONS } from '../data/nflTeams';
import './TeamAuswahl.css';

// Team wählen über Logos: ein Button zeigt die Auswahl, ein Klick öffnet
// ein Sheet mit allen wählbaren Teams (nach Division gruppiert, wenn es
// mehr als eine Division ist). Gedacht für Handy und Desktop gleichermaßen.
//
// value        Team-Kürzel oder ''/null
// teams        wählbare Kürzel
// ausschliessen Kürzel, die anderswo schon gewählt sind (werden ausgegraut)

function TeamAuswahl({ label, value, teams, onChange, disabled = false, ausschliessen = [], platzhalter = 'Team wählen' }) {
  const [offen, setOffen] = useState(false);
  const team = value ? NFL_TEAMS[value] : null;

  useEffect(() => {
    if (!offen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOffen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [offen]);

  const gruppen = Object.entries(DIVISIONS)
    .map(([name, kuerzel]) => ({ name, kuerzel: kuerzel.filter(k => teams.includes(k)) }))
    .filter(g => g.kuerzel.length > 0);
  const gruppiert = gruppen.length > 1;

  const waehle = (kuerzel) => {
    onChange(kuerzel);
    setOffen(false);
  };

  return (
    <div className="team-auswahl">
      {label && <span className="team-auswahl__label">{label}</span>}
      <button
        type="button"
        className={`team-auswahl__button${team ? ' hat-team' : ''}`}
        onClick={() => !disabled && setOffen(true)}
        disabled={disabled}
      >
        {team ? (
          <>
            <img className="team-auswahl__logo" src={team.logo} alt="" />
            <span className="team-auswahl__name">
              <strong>{value}</strong>
              <span>{team.name}</span>
            </span>
          </>
        ) : (
          <span className="team-auswahl__platzhalter">{disabled ? '–' : platzhalter}</span>
        )}
        {!disabled && <span className="team-auswahl__pfeil">▾</span>}
      </button>

      {offen && (
        <div className="team-sheet" onClick={() => setOffen(false)} role="dialog" aria-label={label || 'Team wählen'}>
          <div className="team-sheet__inhalt" onClick={e => e.stopPropagation()}>
            <div className="team-sheet__kopf">
              <strong>{label || 'Team wählen'}</strong>
              <button type="button" className="team-sheet__schliessen" onClick={() => setOffen(false)} aria-label="Schließen">✕</button>
            </div>
            <div className="team-sheet__scroll">
              {gruppen.map(g => (
                <div key={g.name} className="team-sheet__gruppe">
                  {gruppiert && <div className="team-sheet__gruppenname">{g.name}</div>}
                  <div className="team-sheet__grid">
                    {g.kuerzel.map(k => {
                      const t = NFL_TEAMS[k];
                      const belegt = ausschliessen.includes(k) && k !== value;
                      return (
                        <button
                          key={k}
                          type="button"
                          className={`team-kachel${k === value ? ' ist-gewaehlt' : ''}${belegt ? ' ist-belegt' : ''}`}
                          onClick={() => !belegt && waehle(k)}
                          disabled={belegt}
                          title={belegt ? `${t.name} ist schon gewählt` : t.name}
                        >
                          <img src={t.logo} alt="" />
                          <span>{k}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
              {value && (
                <button type="button" className="team-sheet__entfernen" onClick={() => waehle('')}>
                  Auswahl entfernen
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeamAuswahl;
